module.exports = __webpack_public_path__ + "files/91839be05bf95744dae6c5e2c2509e11.png";